import { t } from 'i18next';
import { CollapsibleOngoing } from '../../../../components/CollapsibleCard/CollapsibleOngoing';

export const OnGoingContent = ({ dataRequest, headersFetch, companyID, isRefreshing }) => {
  const { data, isLoading, isFetching, error } = dataRequest;

  if (error) return <div>{t('OnboardingRequestFailed')}</div>;

  if (isLoading || isFetching || isRefreshing)
    return (
      <div className="flex flex-row items-center justify-center gap-2">
        <div className="h-4 w-4 animate-spin rounded-full border-2 border-black"></div>
        <span>{t('OnboardingRequestLoadingData')}</span>
      </div>
    );

  return (
    <>
      <CollapsibleOngoing dataResponse={data} headers={headersFetch} companyID={companyID} />
    </>
  );
};
